import React, { Component } from 'react'
import OrdersEnum from '../OrdersEnum'

class Orders extends Component {
  render() {
    return <OrdersEnum />
  }
}

export default Orders



// WEBPACK FOOTER //
// ./src/components/List/Orders/index.jsx